<template>
  <v-card>
    <v-toolbar dense card class="elevation-2">
      <v-toolbar-title class="body-2 beez-bold "
        >Inbound Packages
      </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="importDialog = true">
          <v-icon>add</v-icon>
        </v-btn>
        <span>Import package</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="importFromFileDialog = true">
          <v-icon>drive_folder_upload</v-icon>
        </v-btn>
        <span>Import package from server path</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="refresh()">
          <v-icon>cached</v-icon>
        </v-btn>
        <span>Refresh</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-title>
      <v-list-tile-content>
        <v-list-tile-sub-title>
          <v-text-field
            color="secondary"
            label="Search"
            v-model="searchItem"
            xs5
          >
          </v-text-field>
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="refresh">
          <v-icon>search</v-icon>
        </v-btn>
        <span>Search</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="searchItem = ''">
          <v-icon>clear</v-icon>
        </v-btn>
        <span>Clear search</span>
      </v-tooltip>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="tableItems"
      item-key="hexId"
      :loading="packageLoader"
      :total-items="pagination.totalItems"
      :pagination.sync="pagination"
      :rows-per-page-items="headerPageItems"
    >
      <v-progress-linear slot="progress" color="accent" indeterminate />
      <template slot="items" slot-scope="props">
        <tr>
          <td @click="props.expanded = !props.expanded" class="text-xs-left">
            <div class="body-1 font-weight-bold" v-if="props.item.hexId">
              {{ props.item.hexId }}
            </div>
            <div class="caption">
              {{
                changeCase(props.item.packageType) +
                  ' | ' +
                  props.item.packageManifestModel.packageId
              }}
            </div>
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-left">
            <div class="body-1 font-weight-bold">
              {{ props.item.description }}
            </div>
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-left">
            <div
              :class="
                props.item.packageStatus === 'FAILED'
                  ? 'red--text'
                  : props.item.packageStatus === 'SUCCESSFUL'
                  ? 'green--text'
                  : 'blue--text'
              "
            >
              <div
                class="body-1 font-weight-bold"
                v-if="props.item.packageStatus"
              >
                {{ changeCase(props.item.packageStatus) }}
              </div>
            </div>
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-left">
            <div class="body-1 font-weight-bold" v-if="props.item.createdAt">
              {{ props.item.createdAtLocal }}
            </div>
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-left">
            <div class="body-1 font-weight-bold" v-if="props.item.createdBy">
              {{ props.item.createdByByLocal || props.item.createdBy }}
            </div>
          </td>
          <td class="align-center justify-center fill-height">
            <v-btn
              v-if="can('CHECK_INBOUND_PACKAGE')"
              :key="props.item.hexId + 'retrigger'"
              :loading="props.item.checkLoader"
              @click="checkPackage(props.item, true)"
              flat
              icon
            >
              <v-icon medium>
                check_circle
              </v-icon>
            </v-btn>
          </td>
          <td class="align-center justify-center fill-height">
            <v-btn
              v-if="can('DEPLOY_INBOUND_PACKAGE')"
              :key="props.item.hexId + 'retrigger'"
              :loading="props.item.deployLoader"
              @click="initDeployPackage(props.item)"
              flat
              icon
            >
              <v-icon medium>
                file_download
              </v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <package-detail
          :a-package="props.item"
          :check-result="props.item.checkResult"
          :check-loader="props.item.checkLoader"
          :inbound-packages="true"
          @checkPackage="checkPackage(props.item, true)"
        ></package-detail>
      </template>
    </v-data-table>
    <v-dialog v-model="importFromFileDialog" max-width="60%">
      <template>
        <v-card>
          <v-toolbar dense card class="elevation-2">
            <v-toolbar-title class="body-2 beez-bold ">
              Import a new package from server path
            </v-toolbar-title>
            <v-layout justify-end align-center>
              <v-btn flat icon @click.stop="importFromFileDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="accent"
            class="ma-0"
            height="5"
            :active="importFromFileLoader"
          />
          <v-layout row wrap class="beez-padding">
            <v-flex xs12>
              <v-form
                ref="importPackageFromFileForm"
                v-model="valid"
                :class="$vuetify.dark ? 'card-dark pa-2' : 'card-light pa-2'"
                lazy-validation
              >
                <v-text-field
                  v-model="importFromFileHexId"
                  :error="!importFromFileHexId"
                  :rules="importFromFilePathRules"
                  label="Package Id"
                  required
                  :disabled="importFromFileLoader"
                ></v-text-field>
              </v-form>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                class="text-capitalize"
                :class="!$vuetify.dark ? 'secondary' : ''"
                :color="$vuetify.dark ? 'secondary' : ''"
                :outline="$vuetify.dark"
                @click="importPackageFromFile"
                :loading="importFromFileLoader"
                >Import
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-dialog v-model="importDialog" max-width="60%">
      <template>
        <v-card>
          <v-toolbar dense card class="elevation-2">
            <v-toolbar-title class="body-2 beez-bold ">
              Import a new package
            </v-toolbar-title>
            <v-layout justify-end align-center>
              <v-btn flat icon @click.stop="importDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="accent"
            class="ma-0"
            height="5"
            :active="importLoader"
          />
          <v-layout row wrap class="beez-padding">
            <v-flex xs12>
              <div class="v-input">
                <v-btn
                  flat
                  class="text-capitalize"
                  color="secondary"
                  @click="$refs.updateBinInput.click()"
                >
                  <v-icon>
                    cloud_upload
                  </v-icon>
                  <span>&nbsp; Add the package file (.zip file)</span>
                </v-btn>
                <input
                  @change="uploadPackageFile"
                  v-show="false"
                  ref="updateBinInput"
                  type="file"
                  :accept="acceptFormats"
                />
              </div>
            </v-flex>
            <v-flex xs12 v-if="binFile">
              <v-card
                :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
                style="border-radius: 5px"
              >
                <v-toolbar flat>
                  <div>Package details</div>
                  <v-spacer></v-spacer>
                  <v-icon>attachment</v-icon>
                </v-toolbar>
                <v-card-title primary-title>
                  <div>
                    <div class="subheading">File name: {{ binFile.name }}</div>
                  </div>
                </v-card-title>
                <v-card-text>
                  <div>
                    <div class="text-xs-left body-1">
                      File size (in Bytes): {{ binFile.size }}
                    </div>
                    <div class="text-xs-left caption">
                      Last modified date: {{ binFile.lastModifiedDate }}
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                class="text-capitalize"
                :class="!$vuetify.dark ? 'secondary' : ''"
                :color="$vuetify.dark ? 'secondary' : ''"
                :outline="$vuetify.dark"
                :disabled="!binFile"
                @click="importPackage"
                :loading="importLoader"
                >Import
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-dialog v-model="showDeploymentConfirmation" max-width="80%">
      <template>
        <v-card v-if="selectedPackage">
          <v-toolbar dense card class="elevation-2">
            <v-toolbar-title class="body-2 beez-bold ">
              Confirm Deploying Package - {{ selectedPackage.hexId }}
            </v-toolbar-title>
            <v-layout justify-end align-center>
              <v-btn flat icon @click.stop="showDeploymentConfirmation = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="accent"
            class="ma-0"
            height="5"
            :active="hiveLoader || checkLoader"
          />
          <v-card-text>
            <v-card
              xs12
              :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
              style="border-radius: 5px"
            >
              <v-toolbar flat dense>
                <v-toolbar-title class="body-2 beez-bold "
                  >Package Details</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn
                  flat
                  icon
                  @click="showPackageDetail = !showPackageDetail"
                >
                  <v-icon
                    >{{ showPackageDetail ? 'expand_less' : 'expand_more' }}
                  </v-icon>
                </v-btn>
              </v-toolbar>
              <div v-if="showPackageDetail">
                <package-detail
                  :a-package="selectedPackage"
                  :check-result="selectedPackage.checkResult"
                  :check-loader="selectedPackage.checkLoader"
                  :inbound-packages="false"
                ></package-detail>
              </div>
            </v-card>
            <br />
            <v-card
              v-if="botTemplateTable && botTemplateTable.length > 0"
              :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
              style="border-radius: 5px"
            >
              <v-toolbar flat dense>
                <v-toolbar-title class="body-2 beez-bold "
                  >Confirm Automation Agent for the Bot
                  templates</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <v-btn
                    icon
                    flat
                    :loading="hiveLoader"
                    slot="activator"
                    @click="getHives"
                  >
                    <v-icon>update</v-icon>
                  </v-btn>
                  <span>Update Automation Agent list</span>
                </v-tooltip>
              </v-toolbar>
              <v-card-text>
                <v-card xs12 class="pa-2">
                  <v-data-table
                    :headers="headersTemplates"
                    :items="botTemplateTable"
                    item-key="sourceId"
                    :loading="hiveLoader || checkLoader"
                  >
                    <v-progress-linear
                      slot="progress"
                      color="accent"
                      indeterminate
                    />
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-left">
                        <div class="body-1">
                          {{ props.item.sourceId }}
                        </div>
                      </td>
                      <td class="text-xs-left">
                        <div class="body-1">
                          {{ props.item.agentType }}
                        </div>
                      </td>
                      <td class="text-xs-left">
                        <div class="body-1">
                          <v-select
                            :items="
                              hives.filter(
                                i => i.hiveType === props.item.agentType
                              )
                            "
                            v-model="props.item.agentId"
                            item-text="name"
                            item-value="hexId"
                          >
                          </v-select>
                        </div>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                class="text-capitalize"
                :class="!$vuetify.dark ? 'secondary' : ''"
                :color="$vuetify.dark ? 'secondary' : ''"
                :outline="$vuetify.dark"
                :loading="selectedPackage.deployLoader"
                @click="deployPackage(selectedPackage)"
                >Confirm
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import PackageDetail from '@/components/package-management/PackageDetail'
import _ from 'lodash'

export default {
  name: 'InboundPackage',
  components: {
    PackageDetail
  },
  data() {
    return {
      botTemplateTable: [],
      allContents: [],
      showDeploymentConfirmation: false,
      hiveLoader: false,
      selectedPackage: null,
      showPackageDetail: false,
      importForm: null,
      acceptFormats: '.zip',
      binFile: null,
      importLoader: false,
      checkLoader: false,
      importDialog: false,
      importFromFileDialog: false,
      importFromFileLoader: false,
      importFromFileHexId: '',
      valid: true,
      importFromFilePathRules: [
        v => !!v || 'Package Id is required',
        v =>
          (v && v.length === 36) ||
          'Package Id should be a UUID of length 36 characters',
        v =>
          (v &&
            _.isArray(
              v
                .toString()
                .match(
                  '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}'
                )
            )) ||
          'Package Id should be a UUID'
      ],
      tableItems: [],
      searchItem: '',
      packageLoader: false,
      currentPage: 0,
      sortBy: '',
      rowsPerPage: 0,
      descending: false,
      pagination: {
        sortBy: 'createdAt',
        rowsPerPage: 10,
        descending: true,
        totalItems: 0,
        page: 1
      },
      headerPageItems: [5, 10, 25],
      search: '',
      headers: [
        {
          text: 'Package ID / Unique reference number',
          align: 'left',
          value: 'hexId',
          sortable: false
        },
        { text: 'Package Description', value: 'description' },
        { text: 'Package status', value: 'packageStatus' },
        { text: 'Created At', value: 'createdAt' },
        { text: 'Created By', value: 'createdBy' },
        { text: 'Check', align: 'center', value: 'check', sortable: false },
        { text: 'Deploy', align: 'center', value: 'retrigger', sortable: false }
      ],
      headersTemplates: [
        { text: 'Source Id', value: 'sourceId' },
        { text: 'Agent Type', value: 'agentType' },
        { text: 'Automation Agent', value: 'agentId' }
      ]
    }
  },
  computed: {
    ...mapState({
      totalPackages: state => state.packages.inboundPackageCount,
      packages: state => state.packages.inboundPackages,
      honeyUsers: state => state.honeyUsers.honeyUsers,
      hives: state => state.hives.hives
    }),
    ...mapGetters({
      can: 'can'
    })
  },
  mounted() {
    this.pagination.totalItems = this.totalPackages
  },
  watch: {
    pagination: {
      handler() {
        try {
          if (
            this.pagination.page !== this.currentPage ||
            this.pagination.rowsPerPage !== this.rowsPerPage ||
            this.pagination.sortBy !== this.sortBy ||
            this.pagination.descending !== this.descending
          ) {
            this.currentPage = this.pagination.page
            this.rowsPerPage = this.pagination.rowsPerPage
            this.sortBy = this.pagination.sortBy
            this.descending = this.pagination.descending
            this.refresh()
          }
        } catch (
          error
          // eslint-disable-next-line no-empty
        ) {}
      },
      deep: true
    },

    totalPackages() {
      this.pagination.totalItems = this.totalPackages
    },
    packages() {
      let packagesList = _.clone(this.packages)
      this.tableItems = packagesList.map(e => {
        try {
          e.createdByByLocal = this.honeyUsers.find(
            user => user.hexId === e.createdBy
          ).username
          e.deployLoader = false
          // eslint-disable-next-line no-empty
        } catch (ex) {}
        return e
      })
    }
  },
  methods: {
    changeCase(str) {
      return _.startCase(_.lowerCase(str))
    },

    setItemDeployLoader(aPackage, flag) {
      this.tableItems = this.tableItems.map(item => {
        if (aPackage.hexId === item.hexId) {
          item.deployLoader = flag
        }
        return item
      })
    },

    setItemCheckLoader(aPackage, flag) {
      this.tableItems = this.tableItems.map(item => {
        if (aPackage.hexId === item.hexId) {
          item.checkLoader = flag
        }
        return item
      })
    },

    setItemCheck(aPackage, checkResult) {
      this.tableItems = this.tableItems.map(item => {
        if (aPackage.hexId === item.hexId) {
          item.checkResult = checkResult
        }
        return item
      })
    },

    async refresh() {
      this.packageLoader = true
      let urlParams = ''
      urlParams = `page=${this.pagination.page}`
      if (this.pagination.rowsPerPage !== -1) {
        urlParams =
          urlParams +
          `&size=${this.pagination.rowsPerPage}&sort=${this.pagination.sortBy}${
            this.pagination.descending ? ',desc' : ''
          }`
      }
      if (this.searchItem !== '') {
        urlParams = urlParams + `&search=${this.searchItem}`
      }
      try {
        await this.$store.dispatch('fetchInboundPackages', urlParams)
        await this.$store.dispatch('fetchInboundPackagesCount')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Error in getting packages',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.packageLoader = false
    },

    async initDeployPackage(aPackage) {
      if (!this.hives || this.hives.length === 0) {
        await this.getHives()
      }
      await this.checkPackage(aPackage, false)
      this.selectedPackage = this.tableItems.find(
        item => item.hexId === aPackage.hexId
      )
      this.fillContents()
      let _self = this
      this.botTemplateTable = []
      this.selectedPackage.checkResult.forEach(i => {
        if (
          i.packageContentType === 'BOT_TEMPLATE' &&
          i.packageActionType === 'NEW'
        ) {
          let botTemplate = {}
          let content = _self.allContents.find(j => j.sourceId === i.sourceId)
          botTemplate.sourceId = i.sourceId
          botTemplate.agentType = content.metadata.hiveType
          botTemplate.agentId = null

          this.botTemplateTable.push(botTemplate)
        }
      })
      this.showDeploymentConfirmation = true
    },

    fillContents() {
      this.allContents = []
      this.selectedPackage.packageManifestModel.contents.forEach(i => {
        this.fillContent(i)
      })
    },

    fillContent(i) {
      let item = {}
      item.sourceId = i.hexId
      item.metadata = i.contentMetaData
      this.allContents.push(item)
      i.dependencies.forEach(j => {
        this.fillContent(j)
      })
    },

    async getHives() {
      this.hiveLoader = true
      try {
        await this.$store.dispatch('fetchHives')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Agent',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.hiveLoader = false
    },

    triggerDeployment: async function(aPackage) {
      this.selectedPackage.deployLoader = true
      this.setItemDeployLoader(aPackage, true)
      try {
        let data = {}
        data.id = aPackage.hexId
        let map = {}
        this.botTemplateTable.forEach(item => {
          map[item.sourceId] = item.agentId
        })
        data.body = {}
        data.body.botTemplateHiveMapping = map
        await this.$store.dispatch('deploySelectedPackage', data)
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Package deployed successfully',
          description: `Package ${aPackage.hexId} has been deployed successfully`,
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Error in deploying package',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      await this.refresh()
      this.showDeploymentConfirmation = false
      this.selectedPackage.deployLoader = false
      this.setItemDeployLoader(aPackage, false)
    },
    async deployPackage(aPackage) {
      try {
        this.validateDeployment(aPackage)
        await this.triggerDeployment(aPackage)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Error in importing package',
          description: e.message,
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
    },

    async checkPackage(aPackage, notify) {
      this.checkLoader = true
      this.setItemCheckLoader(aPackage, true)
      try {
        this.setItemCheck(
          aPackage,
          await this.$store.dispatch('checkSelectedPackage', aPackage.hexId)
        )
        if (notify) {
          await this.$store.dispatch('directNotification', {
            type: 'success',
            message: 'Package check successful',
            description: `Package ${aPackage.hexId} has been checked successfully`,
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        }
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Error in check package',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.setItemCheckLoader(aPackage, false)
      this.checkLoader = false
    },

    async uploadPackageFile() {
      this.importForm = new FormData()
      this.binFile = this.$refs.updateBinInput.files[0]
      this.importForm.append('file', this.binFile)
    },

    async importPackageFromFile() {
      if (this.$refs.importPackageFromFileForm.validate()) {
        this.importFromFileLoader = true
        try {
          let response = await this.$store.dispatch(
            'importPackageFromFile',
            this.importFromFileHexId
          )
          await this.refresh()
          await this.$store.dispatch('directNotification', {
            type: 'success',
            message: 'Package imported successfully',
            description: `Package has been imported aa Package Id ${response.hexId} successfully`,
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        } catch (e) {
          await this.$store.dispatch('directNotification', {
            message: 'Error in importing package',
            description: e.response
              ? e.response.data.message
              : 'Error unknown! Kindly retry',
            type: 'error',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        }
        this.importFromFileLoader = false
        this.importFromFileDialog = false
      }
    },

    async importPackage() {
      this.importLoader = true
      try {
        let response = await this.$store.dispatch(
          'importPackage',
          this.importForm
        )
        await this.refresh()
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Package imported successfully',
          description: `Package has been imported aa Package Id ${response.hexId} successfully`,
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Error in importing package',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.importLoader = false
      this.importDialog = false
    },
    validateDeployment() {
      this.botTemplateTable.forEach(item => {
        if (!item.agentId) {
          throw new Error(
            'Agent assignment not found for Bot template : ' + item.sourceId
          )
        }
      })
    }
  }
}
</script>

<style scoped></style>
